import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";

export const ServiceCollaboration = () => {
  const { t } = useLang();

  return (
    <div data-testid="services-collaboration" className="mt-28 border-t border-white/10 pt-16 md:mt-36 md:pt-24">
      <div className="grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20">
        <div>
          <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-[#00F0FF]">
            {t.services.collaboration.overline}
          </p>
          <h2 className="mt-6 max-w-2xl font-heading text-3xl font-medium tracking-tight text-white sm:text-4xl">
            {t.services.collaboration.title}
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400">
            {t.services.collaboration.description}
          </p>

          <div className="mt-10 grid grid-cols-2 gap-6 border-t border-white/10 pt-6">
            {t.services.collaboration.stats.map((stat, index) => (
              <div key={stat.value} data-testid={`services-stat-${index + 1}`}>
                <p className="font-heading text-3xl font-medium text-white sm:text-4xl">{stat.value}</p>
                <p className="mt-2 max-w-[13rem] text-xs leading-relaxed text-zinc-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <motion.figure
            data-testid="services-model-image"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border border-white/10 bg-[#050507]"
          >
            <img src={IMAGES.services.model} alt="" className="aspect-[4/5] h-full w-full object-cover" />
          </motion.figure>
          <motion.figure
            data-testid="services-colocation-image"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.6, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border border-white/10 bg-[#050507]"
          >
            <img src={IMAGES.services.colocation} alt="" className="aspect-[4/5] h-full w-full object-cover" />
          </motion.figure>
          <p className="col-span-2 border-l border-[#00F0FF] pl-4 text-sm leading-relaxed text-zinc-400">
            {t.services.collaboration.imageLabel}
          </p>
        </div>
      </div>
    </div>
  );
};